module.exports = __webpack_public_path__ + "img/bs.bf21a7dc.svg";